import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'Modals/ModalComponent/Modal';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import LoginForm from 'Components/Forms/LoginForm';
import PasswordRecoveryForm from 'Components/Forms/PasswordRecoveryForm';
import Loader from 'Pure/Loader';
export default class LoginModal extends Component {
  state = {
    loading: false,
    error: undefined,
    forgotten_password: false,
    status_messages: {}
  };
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.open === true && props.open === false) {
      component.handleClose();
    }
  }
  handleClose = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login: false,
      error: undefined,
      forgotten_password: false
    });
  };
  handleValidation = (user = {}) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login: true
    });
    if (typeof props.onLogin === 'function') {
      props.onLogin(user);
    }
  };
  forgottenPassword = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      forgotten_password: !state.forgotten_password
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['black', 'bg-white']
    }) : undefined;
    const status = getFormStatus(state);
    const success = state.login === true ? getFormStatus({
      info: 'Connexion réussie.'
    }) : undefined;
    const output = /*#__PURE__*/React.createElement(Modal, {
      open: props.open === true,
      onClose: props.onClose,
      title: state.forgotten_password ? "Récupération de mot de passe" : "Connexion",
      "scroll-area": props['scroll-area'] || '.front-page, .back-page',
      "with-footer-close": false,
      bemit: props.bemit || ['small', 'simple'],
      src: props.trigger_src,
      close_label: state.login === true ? 'Fermer' : 'Annuler',
      close_classes: "c-flat-btn c-flat-btn--primary"
    }, state.forgotten_password ? /*#__PURE__*/React.createElement(PasswordRecoveryForm, null) : /*#__PURE__*/React.createElement(LoginForm, {
      onLogin: component.handleValidation,
      onForgottenPassword: component.forgottenPassword,
      redirect: false
    }), status, success, props.children, loader);
    return output;
  }
}
LoginModal.propTypes = {
  open: PropTypes.bool,
  scroll_area: PropTypes.string,
  trigger_src: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onLogin: PropTypes.func
};
